import { render, staticRenderFns } from "./Ibox.vue?vue&type=template&id=7ffbf3a6&scoped=true&"
import script from "./Ibox.vue?vue&type=script&lang=js&"
export * from "./Ibox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffbf3a6",
  null
  
)

export default component.exports